import { gql } from 'apollo-angular';

const GET_POTENTIAL_SAVINGS_STATISTICS = gql`
  query getPotentialSavingsStatistics(
    $organizationId: Long
    $categorizationSchemeName: String
  ) {
    catalogStatistics(
      organizationId: $organizationId
      categorizationSchemeName: $categorizationSchemeName
    ) {
      potentialSavingsStatistics {
        categoryCount
        alertLevel
      }
    }
  }
`;

export default GET_POTENTIAL_SAVINGS_STATISTICS;
